import { render, staticRenderFns } from "./decisionData.vue?vue&type=template&id=11b304b1&scoped=true"
import script from "./decisionData.vue?vue&type=script&lang=js"
export * from "./decisionData.vue?vue&type=script&lang=js"
import style0 from "./decisionData.vue?vue&type=style&index=0&id=11b304b1&prod&scoped=true&lang=scss"
import style1 from "./decisionData.vue?vue&type=style&index=1&id=11b304b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b304b1",
  null
  
)

export default component.exports